export default "__VITE_ASSET__BJKJQrbv__"